module.exports = __webpack_public_path__ + "chromosom17_Genotyping_v2.png?162e0fd6cd6de3bfbfde73c2cba78333";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chromosom17_Genotyping_v2.png
// module id = 48
// module chunks = 0